<template>
  <div id="app">
    <FileMenu
      :key="NaN"
      @close-menu="fileMenuOpen=false"
      @load-project="loadWorkspaceFromCache($event)"
      @download-project="downloadProject"
      @rename-project="renameProject"
      @delete-project="deleteProject"
      :fileMenuOpen="fileMenuOpen"
      :savedProjects="savedProjects"
      :currentProject="currentProject"
    ></FileMenu>
    <div id="grid">
      <TopBar/>
      <ControlBar
        ref="controlBar"
        @change-sidebar-view="changeSidebarView"
        @run-code="runCode"
        @emergency-land="cancelRun"
        @emergency-cutoff="emergencyCutoff"
        @save-project="saveProject"
        @save-as="saveAs"
        @new-project="newProject"
        @open-project="fileMenuOpen=true"
        @download-project="downloadProject"
        @import-project="importProject"
        @toggle-text-mode="toggleTextMode"
        :codeRunningState="codeRunningState"
        :sidebarViewState="sidebarViewState"
        :droneConnectedState="droneConnectionState"
        :workspace="workspace"
        
      ></ControlBar>

      <splitpanes class="default-theme" :class="{'fat-finger': usingTouchDevice, 'code-editor-pane':textEditorOpen}" id='mainContent' :dbl-click-splitter="false" @resize="sidebarSize=$event[0].size">
        <pane v-if="sidebarViewState" id='sidebarPane' min-size="15" max-size="60" :size="sidebarSize">
          <div class="sidebar">
            <!-- <CodeDisplay v-if="sidebarViewState=='code'"
              :displayLanguage="codeDisplayLanguage"
              :javascriptCode="compiledJavascript" 
              :pythonCode="compiledPython"
              @language-changed="codeDisplayLanguage=$event"
            >code</CodeDisplay> -->

            <DroneDevice v-if="sidebarViewState=='drone'"
              :droneController="droneController" :connectedState="droneConnectionState"
              @connect-drone="connectToDrone"
              @disconnect-drone="disconnectDrone"
            ></DroneDevice>

            <OutputConsole v-if="sidebarViewState=='console'"
              :outputLog="consoleOutputLog"
              @clear-console="clearConsole"
            >console</OutputConsole>
          </div>    
        </pane>
        <pane id='editorPane' @hook:updated="resizeBlockly" :size="100 - sidebarSize">
          <div v-if="codeRunningState == 'running'" class="disable-editor"></div>
          <text-editor
            ref="textEditor"
            v-if="textEditorOpen" 
            :startingCode="textEditorCode" 
            @code-modified="markModified"
          />
          <div id="blocklyArea" ref="blocklyArea" v-show="!textEditorOpen">
          </div>   
          
        </pane>
      </splitpanes>
      <FooterComponent />
    </div>
    <!-- <p class='footer'>FTWCODE is currently in Beta and only supports the Parrot Mambo. All other drones are not fully supported at this time.</p> -->
    
    <div id='blocklyDiv' ref="blocklyDiv">
      <div style='height: 0px; overflow: hidden; width: 0px'>
        <svg width="125" height="125"><defs><pattern id="blockly_canvas_fill" patternUnits="userSpaceOnUse" width="125" height="125"><use xlink:href="#blockly_sq" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(12.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(25)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(37.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(50)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(62.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(75)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(87.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(100)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(112.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(0 12.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(12.5 12.5)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(25 12.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(37.5 12.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(50 12.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(62.5 12.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(75 12.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(87.5 12.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(100 12.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(112.5 12.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(0 25)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(12.5 25)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(25 25)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(37.5 25)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(50 25)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(62.5 25)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(75 25)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(87.5 25)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(100 25)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(112.5 25)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(0 37.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(12.5 37.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(25 37.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(37.5 37.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(50 37.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(62.5 37.5)" fill="#F8F8F8"></use><use xlink:href="#blockly_sq" transform="translate(75 37.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(87.5 37.5)" fill="#F9F9F9"></use><use xlink:href="#blockly_sq" transform="translate(100 37.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(112.5 37.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(0 50)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(12.5 50)" fill="#F8F8F8"></use><use xlink:href="#blockly_sq" transform="translate(25 50)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(37.5 50)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(50 50)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(62.5 50)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(75 50)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(87.5 50)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(100 50)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(112.5 50)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(0 62.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(12.5 62.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(25 62.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(37.5 62.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(50 62.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(62.5 62.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(75 62.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(87.5 62.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(100 62.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(112.5 62.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(0 75)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(12.5 75)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(25 75)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(37.5 75)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(50 75)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(62.5 75)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(75 75)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(87.5 75)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(100 75)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(112.5 75)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(0 87.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(12.5 87.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(25 87.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(37.5 87.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(50 87.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(62.5 87.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(75 87.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(87.5 87.5)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(100 87.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(112.5 87.5)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(0 100)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(12.5 100)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(25 100)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(37.5 100)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(50 100)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(62.5 100)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(75 100)" fill="#FAFAFA"></use><use xlink:href="#blockly_sq" transform="translate(87.5 100)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(100 100)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(112.5 100)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(0 112.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(12.5 112.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(25 112.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(37.5 112.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(50 112.5)" fill="#FBFBFB"></use><use xlink:href="#blockly_sq" transform="translate(62.5 112.5)" fill="#FFF"></use><use xlink:href="#blockly_sq" transform="translate(75 112.5)" fill="#FEFEFE"></use><use xlink:href="#blockly_sq" transform="translate(87.5 112.5)" fill="#FCFCFC"></use><use xlink:href="#blockly_sq" transform="translate(100 112.5)" fill="#FDFDFD"></use><use xlink:href="#blockly_sq" transform="translate(112.5 112.5)" fill="#FBFBFB"></use></pattern><path id="blockly_sq" d="M0 0h12.5v12.5H0V0z"></path></defs></svg>
      </div>
    </div>
    
    
    
  </div>
</template>

<script>
const log = console.log;
//Component imports
import ControlBar from './components/ControlBar';
import DroneDevice from './components/DroneDevice';
// import CodeDisplay from './components/CodeDisplay';
import OutputConsole from './components/OutputConsole';
import TopBar from './components/TopBar';
import FooterComponent from './components/FooterComponent';
import FileMenu from './components/FileMenu';
import TextEditor from './components/TextEditor';

//Blockly built-in imports
import Blockly from 'blockly';
import BlocklyJS from 'blockly/javascript';
import BlocklyPython from 'blockly/python';

//Blockly custom imports
import './blockly-config/custom_blocks';
import './blockly-config/custom_blocks_python'
// import './blockly-config/prompt';

//Other imports
import {FlightError, MamboController} from './drone';
import axios from 'axios';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import Swal from 'sweetalert2';
import codeToBlockXml from './codeToBlocks';


export default {
  name: 'app',
  components: {
    TopBar,
    ControlBar,
    DroneDevice,
    // CodeDisplay,
    OutputConsole,
    FooterComponent,
    Splitpanes, 
    Pane,
    FileMenu,
    TextEditor
  },
  data(){
    return {
      workspace: null,
      droneController: null,
      droneConnectionState: 'disconnected',
      codeRunningState: 'not running',
      sidebarViewState: null,
      textEditorOpen: false,
      textEditorCode: '',
      fileMenuOpen: false,
      codeDisplayLanguage: 'python',
      sidebarSize: 20,
      consoleOutputLog: [],
      isMounted: false,
      resizeBlockly: ()=>{},
      keysPressed: {
        'ArrowUp': false,
        'ArrowDown': false,
        'ArrowLeft': false,
        'ArrowRight': false,
        "a":false,
        "b":false,
        "c":false,
        "d":false,
        "e":false,
        "f":false,
        "g":false,
        "h":false,
        "i":false,
        "j":false,
        "k":false,
        "l":false,
        "m":false,
        "n":false,
        "o":false,
        "p":false,
        "q":false,
        "r":false,
        "s":false,
        "t":false,
        "u":false,
        "v":false,
        "w":false,
        "x":false,
        "y":false,
        "z":false,
      },
      keyPressListeners: {
        'pressed': {},
        'released': {}
      },
      droneEventListeners: {
        flying: null,
        landed: null,
        batteryLevelChanged: null,
        crashed: null
      },
      blocklyOptions: {
        disable: false,
        media: 'media/',
        grid: {
            spacing: 25,
            length: 1,
            colour: '#ccc',
            snap: true
        },
        maxInstances: {
          "program_start": 1
        },
        toolbox: null,
        zoom: {
          controls: true,
          wheel: false,

        }
      },
      savedProjects: [],
      currentProject: {
        id: null,
        modified: false
      },
      disabledBlockStorage: []
    }
  },
  computed: {
    //this is for real-time rendering of the code created by blockly - display only
    compiledJavascript: function () {
      if(!this.isMounted){
        return '';
      }
      return BlocklyJS.workspaceToCode(this.workspace);
    },
    compiledPython: function () {
      if(!this.isMounted){
        return '';
      }
      return BlocklyPython.workspaceToCode(this.workspace);
    },
    usingTouchDevice () {
      return ( 'ontouchstart' in window ) ||  
           ( navigator.maxTouchPoints > 0 ) ||  
           ( navigator.msMaxTouchPoints > 0 );
    }
  },
  methods: {

    async connectToDrone() {
      try{
        console.log('=============', navigator)
        if(!navigator.bluetooth){
          alert('This browser does not support Bluetooth connection. Use the latest version of Google Chrome(on Android, Chrome OS, Mac and Windows) for best results. iOS devices are not supported at this time.');
          return;
        }
        //Connect to the drone's BLE device by prompting user
        let droneBluetoothDevice = await navigator.bluetooth.requestDevice({
            filters: [
                {namePrefix: "Mambo_"},
                {namePrefix: "mambo_"},
                {namePrefix: "MAMBO_"},
                {namePrefix: "TRAVIS_"},
                {namePrefix: "Travis_"},
                {namePrefix: "travis_"},
                {namePrefix: "FTW_"},
                {namePrefix: "ftw_"},
                {namePrefix: "Mars_"},
                {namePrefix: "Hopper_"},
                {namePrefix: "hopper_"},
                {namePrefix: "HOPPER_"},
                {namePrefix: "Hopper"},
                {namePrefix: "hopper"},
                {namePrefix: "HOPPER"},
            ],
            optionalServices: [
                '9a66fa00-0800-9191-11e4-012d1540cb8e',
                '9a66fb00-0800-9191-11e4-012d1540cb8e',
                '9a66fd21-0800-9191-11e4-012d1540cb8e',
                '9a66fd51-0800-9191-11e4-012d1540cb8e'
            ]
        
        });
        //instantiates the drone controller interface with selected drone
        this.droneController = new MamboController(droneBluetoothDevice);
        
        //If the drone still hasn't connected after 30 seconds, alerts the user and aborts the connection 
        this.droneConnectionState = 'connecting';
        setTimeout(()=>{
          if(this.droneConnectionState == 'connecting') {
            alert('Connection failed, restart your drone and try again.');
            location.reload();
          }
        }, 30000);
        //connect to the drone's gatt server and initialize the controller data
        await this.droneController.connect();
        this.droneConnectionState = 'connected';

        //add a listener in case the device disconnects on its own such as from powering off while connected
        this.droneController.droneBluetoothDevice.addEventListener('gattserverdisconnected', async () => {
          await this.disconnectDrone()
        });
      }
      catch (error) {
        console.error(error);
        this.disconnectDrone();
      }
      
    },

    async disconnectDrone() {
      this.droneConnectionState = 'disconnected';
      if(this.codeRunningState == 'running') {
        await this.cancelRun();
      }
      if(this.droneController) await this.droneController.disconnect();
      this.droneController = null;
      console.log('disconnected')
    },

    async runCode() {
      if (this.textEditorOpen) {
        return await this.runTextCode();
      }

      if(this.droneConnectionState != 'connected') {
        // alert('Mini Drone must be connected to run code');
        await Swal.fire({
          type: 'error',
          title: 'Not Connected',
          text: 'Mini Drone must be connected to run code'
        });
        this.sidebarViewState = 'drone';
        return;
      }
      
      //check whether there are any event listener blocks in the workspace
      let eventBasedRun = false;
      let topLevelBlocks = this.workspace.getTopBlocks();
      for(let i=0; i<topLevelBlocks.length; i++) {
        let block = topLevelBlocks[i];
        if (block.type.slice(0,6) == 'event_') {
          eventBasedRun = true;
        }
      }
  
      this.codeRunningState = 'running';
      //configures blockly to handle infinite loops
      window.LoopTrap = 1000;
      Blockly.JavaScript.INFINITE_LOOP_TRAP = 'if(--window.LoopTrap == 0) throw "Infinite loop.";\n';
      //grabs the code from blockly
      let code = BlocklyJS.workspaceToCode(this.workspace);

      // eslint-disable-next-line no-unused-vars
      let drone = this.droneController;
      // eslint-disable-next-line no-unused-vars
      let consoleError = this.consoleError;
      // eslint-disable-next-line no-unused-vars
      let keysPressed = this.keysPressed;
      // eslint-disable-next-line no-unused-vars
      let keyPressListeners = this.keyPressListeners;
      // eslint-disable-next-line no-unused-vars
      let droneEventListeners = this.droneEventListeners;
      // eslint-disable-next-line no-unused-vars
      let stopProgram = this.cancelRun;


      //CUSTOM TRIG FUNCs that take degrees instead of radians
      // eslint-disable-next-line no-unused-vars
      let sin = (arg) => Math.sin(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let cos = (arg) => Math.cos(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let tan = (arg) => Math.tan(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let asin = (arg) => Math.asin(arg) / 180 * Math.PI;
      // eslint-disable-next-line no-unused-vars
      let acos = (arg) => Math.acos(arg) / 180 * Math.PI;
      // eslint-disable-next-line no-unused-vars
      let atan = (arg) => Math.atan(arg) / 180 * Math.PI;
    
      //define function for the "repeat for _ seconds" block to call
      // eslint-disable-next-line no-unused-vars
      async function repeatForSeconds(seconds, callback) {
        let startTime=Date.now();
        while(Date.now()<startTime+seconds*1000) {
          await callback();
        }
      }
      
      console.log = (message) => {
        this.consoleDisplay(message);
      };

      let startProgram = () => {};

      await drone.startRun();
      eval(code);
      try {
        await startProgram();
      } catch(e) {
        consoleError(e);
      }

      //if there are event listeners in the program, wait indefinitely until run is cancelled
      while ( eventBasedRun && !drone.cancelRunFlag ) {
        await drone.wait(0.1);
      }
      
      await drone.stopRun();

      //clears event callbacks that were defined during the run 
      this.resetEventListeners();
      //resets the cancel run flag after the run in case cancelRun was called
      this.droneController.cancelRunFlag = false;
      this.codeRunningState = 'not running';

      return;

    },
    async runTextCode () {

      log(this.$refs.textEditor.codeIsEventBased);

      if(this.droneConnectionState != 'connected') {
        // alert('Mini Drone must be connected to run code');
        await Swal.fire({
          type: 'error',
          title: 'Not Connected',
          text: 'Mini Drone must be connected to run code'
        });
        this.sidebarViewState = 'drone';
        return;
      }

      if(!this.$refs.textEditor.isErrorFree()) {
        await Swal.fire({
          type: 'error',
          title: 'There are errors in your code',
          text: 'Try to fix any errors before running the program again'
        });
        return;
      }

      //check whether there are any event listener blocks in the workspace
      let code = this.$refs.textEditor.code;
      let eventBasedRun = this.$refs.textEditor.codeIsEventBased;

      this.codeRunningState = 'running';

      // eslint-disable-next-line no-unused-vars
      let drone = this.droneController;
      // eslint-disable-next-line no-unused-vars
      let consoleError = this.consoleError;
      // eslint-disable-next-line no-unused-vars
      let keysPressed = this.keysPressed;
      // eslint-disable-next-line no-unused-vars
      let keyPressListeners = this.keyPressListeners;
      // eslint-disable-next-line no-unused-vars
      let droneEventListeners = this.droneEventListeners;
      // eslint-disable-next-line no-unused-vars
      let stopProgram = this.cancelRun;
            
      //CUSTOM TRIG FUNCs that take degrees instead of radians
      // eslint-disable-next-line no-unused-vars
      let sin = (arg) => Math.sin(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let cos = (arg) => Math.cos(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let tan = (arg) => Math.tan(arg / 180 * Math.PI);
      // eslint-disable-next-line no-unused-vars
      let asin = (arg) => Math.asin(arg) / 180 * Math.PI;
      // eslint-disable-next-line no-unused-vars
      let acos = (arg) => Math.acos(arg) / 180 * Math.PI;
      // eslint-disable-next-line no-unused-vars
      let atan = (arg) => Math.atan(arg) / 180 * Math.PI;
      
      //define function for the "repeat for _ seconds" block to call
      // eslint-disable-next-line no-unused-vars
      async function repeatForSeconds(seconds, callback) {
        let startTime=Date.now();
        while(Date.now()<startTime+seconds*1000) {
          await callback();
        }
      }

      console.log = (message) => {
        this.consoleDisplay(message);
      };

      let startProgram = () => {};
      log('starting run...');
      await drone.startRun();
      try {
        eval(code);
      } catch (e) {
        console.log(e);
      }
      try {
        await startProgram();
      } catch(e) {
        console.log(e);
      }

      //if there are event listeners in the program, wait indefinitely until run is cancelled
      while ( eventBasedRun && !drone.cancelRunFlag ) {
        await drone.wait(0.1);
      }
      
      await drone.stopRun();

      //clears event callbacks that were defined during the run 
      this.resetEventListeners();
      //resets the cancel run flag after the run in case cancelRun was called
      this.droneController.cancelRunFlag = false;
      this.codeRunningState = 'not running';

    },
    async cancelRun() {
      this.droneController.cancelRunFlag = true;
      await this.droneController.stopRun();
      await this.droneController.forceLand();
      //does this to exit any blockly loops
      window.LoopTrap = 1;
    },
    async emergencyCutoff() {
      await this.droneController.cutoff();
      this.droneController.cancelRunFlag = true;
    },
    showCode() {
      alert(BlocklyJS.workspaceToCode(this.workspace));
    },
    changeSidebarView(selectedView, forceOpen=false) {
      //close sidebar upon clicking the button for the view currently open
      if(this.sidebarViewState == selectedView && !forceOpen) {
        this.sidebarViewState = null;
      
      } else {
        this.sidebarViewState = selectedView;
      }
    },
    clearConsole() {
      this.consoleOutputLog = [];
    },
    consoleDisplay (message) {
      if(message == 'Infinite loop.' || (typeof message == 'string' && message.includes('TypeError'))) return;
      if(this.droneController.cancelRunFlag) return;
      this.consoleOutputLog.push(message);
    },
    consoleError (error) {
      if ( error instanceof FlightError ) {
        this.consoleOutputLog.push(error);
      } else {
        console.error(error);
      }
    },
    clearAllBlocks () {
      this.workspace.clear();
    },
    cleanUpBlocks () {
      this.workspace.cleanUp();
    },
    resetEventListeners() {
      this.keyPressListeners = {
        'pressed': {},
        'released': {}
      };
      this.droneEventListeners = {
        flying: null,
        landed: null,
        batteryLevelChanged: null,
        crashed: null
      };
    },
    async saveProject () {
      if (!this.currentProject.id) {
        //if the project is not yet saved in the cache, call saveAs
        return await this.saveAs();
      } else {
        let currentProject = this.currentProject;
        //update the project's date in the app data
        let project = this.savedProjects.find(x=>x.id === currentProject.id);
        project.date = new Date().toJSON().slice(0,10);

        //update the cached workspace
        let xml = Blockly.Xml.workspaceToDom(this.workspace);
        let xml_text = Blockly.Xml.domToText(xml);
        localStorage.setItem('project_workspace_'+currentProject.id, xml_text);

        //update the cached code
        let code;
        if (this.textEditorOpen) {
          code = this.$refs.textEditor.code
        } else {
          code = '';
        }
        localStorage.setItem('project_code_'+currentProject.id, code);

        //store whether code or block mode is active
        project.textEditorOpen = this.textEditorOpen;

        //update the cached metadata
        let updatedMetadata = JSON.stringify(project);
        localStorage.setItem('project_metadata_'+currentProject.id, updatedMetadata);

        //show confirmation of save
        Swal.fire({
          title: 'Your project has been saved!',
          type: 'success',
          timer: 1000
        }
        );
      }

    },
    async saveAs () {
      //Prompt user for project name
      let {value: fileName} = await Swal.fire({
        title: "Save As...",
        input: 'text',
        inputPlaceholder: 'Name your project...',
        showCancelButton: true,
        inputValidator : (value) => {
          if(!value) {
            return 'Project name cannot be blank';
          }
        }
      });

      //cancel the save if the user cancels the save prompt
      if(!fileName) {return "cancel"}

      //the cache stores the next unused project id;
      //grab it and increment it
      let projectId = Number(localStorage.getItem('next_id')) || 1;
      localStorage.setItem('next_id', projectId+1);

      //construct the metadata for the project
      let projectData = {
        name: fileName,
        id: projectId,
        date: new Date().toJSON().slice(0,10),
        textEditorOpen: this.textEditorOpen
      };
      let projectDataString = JSON.stringify(projectData);

      //grab the current state of the workspace as a string
      let xml = Blockly.Xml.workspaceToDom(this.workspace);
      let xml_text = Blockly.Xml.domToText(xml);

      //store metadata and workspace state in localstorage
      localStorage.setItem('project_metadata_'+projectId, projectDataString);
      localStorage.setItem('project_workspace_'+projectId, xml_text);

      //store code from text editor
      let code;
      if (this.textEditorOpen) {
        code = this.$refs.textEditor.code
      } else {
        code = '';
      }
      localStorage.setItem('project_code_'+projectId, code);

      //update data with new project 
      this.savedProjects.push(projectData);
      Swal.fire({
        title: 'Your project has been saved!',
        type: 'success',
        timer: 1000
      }
      );

      //update the status of the current project
      this.currentProject = {
        id : projectId,
        modified : false
      }
    },
    async promptToSave () {
      //returns "cancel" if user cancels prompt
      if (this.currentProject.modified && this.workspace.getTopBlocks().length > 0) {
        let result = await Swal.fire({
          title: 'Do you want to save the changes to the current project?',
          showCancelButton: true,
          confirmButtonText: `Save`,
          cancelButtonText: `Don't save`,
          showCloseButton: true
        });
        if (result.value) {
          if (await this.saveProject() == 'cancel') return "cancel";
        } else if (result.dismiss == 'close' || result.dismiss == 'backdrop' || result.dismiss == 'esc') {
          return 'cancel';
        }
      }
    },
    async newProject () {
      //prompt user to save work if changes have been made
      if (await this.promptToSave() == 'cancel') return 'cancel';
      this.workspace.clear();
      this.currentProject = {id: null, modified: false};

      this.textEditorOpen = false;
      this.$refs.controlBar.textEditorOpen = false;
      this.textEditorCode = '';
    },
    loadSavedProjects () {
      //pull all of the saved project metadata from the cache and store it in Vue app data
      for(const itemKey in localStorage) {
        if(itemKey.slice(0,17) == 'project_metadata_') {
          this.savedProjects.push(JSON.parse(localStorage[itemKey]));
        }
      }
      //reopen the project that was open last time the app was closed
      let lastOpenedProjectId = JSON.parse(localStorage.getItem('current_project_id'));
      if (lastOpenedProjectId != null) {
        this.loadWorkspaceFromCache(lastOpenedProjectId);
      }
    },
    async loadWorkspaceFromCache (id) {
      //prompt to save current project
      if (await this.promptToSave() == 'cancel') return;

      //grab workspace definition from cache and convert to usable xml
      try {
        let xml_text = localStorage.getItem('project_workspace_'+id);
        if (!xml_text) {
          return;
        }
        let xml = Blockly.Xml.textToDom(xml_text);
        //clear current workspace
        this.workspace.clear();
        //populate workspace with project from cache
        Blockly.Xml.domToWorkspace(xml, this.workspace);

        //check whether project was saved in block or text mode
        let metadata = JSON.parse(localStorage.getItem('project_metadata_'+id));
        if(metadata.textEditorOpen) {
          this.textEditorOpen = true;
          this.$refs.controlBar.textEditorOpen = true;
          //have to wait for text editor to be created before referencing it - hence nexttick
          this.$nextTick(() => {this.$refs.textEditor.code = localStorage.getItem('project_code_'+id);});
          
        } else {
          this.textEditorOpen = false;
          this.$refs.controlBar.textEditorOpen = false;
        }
        
      } catch (error) {
        Swal.fire({
          type: 'error',
          title: 'Error loading project',
        });
      }
      setTimeout(()=>{
        //update the piece of data tracking the currently open project
        //this is delayed 30ms because clearing blockly (workspace.clear() above) takes a few ms to 
        //send a change event which will set currentProject.modified to true
        this.currentProject.id = id;
        this.currentProject.modified = false;
      }, 30);
      
    },
    async downloadProject (xml_text, projectName='') {
      //grab the text code and add it to the end of the xml text (inside <ftwcode></ftwcode> brackets)
      let code;
      if (this.textEditorOpen) {
        code = this.$refs.textEditor.code
      } else {
        code = '';
      }
      // xml_text = xml_text + '<ftwcode>'+code+'</ftwcode>';

      let data = JSON.stringify({
        data: JSON.stringify(xml_text),
        code: code
      });

      // Create an invisible A element
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);

      // Set the HREF to a Blob representation of the data to be downloaded
      a.href = window.URL.createObjectURL(
        new Blob([data], {type: 'text/xml'})
      );

      let {value: fileName} = await Swal.fire({
        title: 'Name Your Download File',
        input: 'text',
        inputValue: projectName,
        inputPlaceholder: 'Project Name',
        showCancelButton : true,
        inputValidator : (value) => {
          if(!value) {
            return 'File name cannot be blank';
          }
        }
      });
      if(fileName) {
        a.setAttribute("download", fileName);
        a.click();
      }
      // Cleanup
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    },
    async importProject (xml_text, code) {
      //prompt user to save their work before loading the new workspace
      if (await this.newProject() == 'cancel') return;
      try {
        let xml = Blockly.Xml.textToDom(xml_text);
        this.workspace.clear();
        Blockly.Xml.domToWorkspace(xml, this.workspace);
        
        //if the project was downloaded in code mode, open it in code mode
        if(code) {
          
          this.textEditorOpen = true;
          this.$refs.controlBar.textEditorOpen = true;
          //have to wait for text editor to be created before referencing it - hence nexttick
          this.$nextTick(() => {this.$refs.textEditor.code = code;});
          
          
        } else {
          this.textEditorOpen = false;
          this.$refs.controlBar.textEditorOpen = false;
        }
      } catch (error) {
        console.error(error);
        //if an invalid workspace is uploaded, textToDom will throw an error - alert user that file is no good
        Swal.fire({
          type: 'error',
          title: 'Error uploading file',
          text: 'File is invalid - make sure it has not been altered after downloading'
        });
      }
      
    },
    async renameProject (id, prevName) {
      let {value: newName} = await Swal.fire({
        title: 'Rename Project',
        input: 'text',
        inputValue: prevName,
        inputPlaceholder: 'Project Name',
        showCancelButton : true,
        inputValidator : (value) => {
          if(!value) {
            return 'Project name cannot be blank';
          }
        }
      });
      //cancel operation if user cancelled prompt
      if (!newName) return;

      //update name in vue data
      let project = this.savedProjects.find(x=>x.id === id);
      project.name = newName;
      //update name in cache
      let updatedMetadata = JSON.stringify(project);
      localStorage.setItem('project_metadata_'+id, updatedMetadata);
    },
    async deleteProject(id) {
      let {value: result} = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!'
      });
      if (result) {
        //if the project to delete is currently open, clear the workspace and reset the current project tracker
        if (this.currentProject.id == id) {
          this.clearAllBlocks();
          this.currentProject = {id: null, modified: false};
        }
        
        //delete from app data
        this.savedProjects = this.savedProjects.filter(x => x.id != id);
        //delete from cache
        localStorage.removeItem('project_workspace_'+id);
        localStorage.removeItem('project_metadata_'+id);
        localStorage.removeItem('project_code_'+id);
        Swal.fire({
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          type: 'success',
          timer: 1000
        });
      }
      
    },
    async toggleTextMode(event) {
      //switching to text mode
      if (event == true) {
        //generate code from blocks
        BlocklyJS.INFINITE_LOOP_TRAP = null;
        let blockCode = BlocklyJS.workspaceToCode(this.workspace);
        this.textEditorCode = blockCode;
        this.storeDisabledBlocks();
        this.textEditorOpen = true;
      } 
      //switching to block mode
      else {
        if(!this.$refs.textEditor.isErrorFree(true)) {
          let {value: cancelToggle, dismiss: cancelMethod} = await Swal.fire({
            type: 'error',
            title: 'There are errors in your code',
            text: 'Either stay in text mode and fix your errors or attempt to convert back to blocks anyways',
            showCancelButton: true,
            confirmButtonText: `Stay in Text mode`,
            cancelButtonText: `Attempt to convert`,
            showCloseButton: true
          });
          if(cancelToggle || ['esc', 'close', 'backdrop'].includes(cancelMethod)) {
            this.textEditorOpen = true;
            this.$refs.controlBar.textEditorOpen = true;
            return;
          }
        }
        //save the previous workspace in case the code fails to convert
        let prevDom = Blockly.Xml.workspaceToDom(this.workspace, true);

        try {
          //generate block workspace dom from code
          let workspaceXml = codeToBlockXml(this.$refs.textEditor.code);
          let workspaceDom = Blockly.Xml.textToDom(workspaceXml);
          //clear current workspace
          this.workspace.clear();
          //populate workspace with generated dom
          Blockly.Xml.domToWorkspace(workspaceDom, this.workspace);
          //restore any disabled top blocks
          this.restoreDisabledBlocks();
          this.cleanUpBlocks();
          //switch to block mode
          this.textEditorOpen = false;
        } catch (e) {
          //if the code->block conversion failed: ask user to revert changes or stay in text mode
          let {value: revertChanges} = await Swal.fire({
            title: 'Error converting code to blocks',
            text: 'You can revert the blocks to how they were last, or keep editing the code.',
            showCancelButton: true,
            confirmButtonText: `Revert changes`,
            focusConfirm: false,
            cancelButtonText: `Keep editing code`,
            showCloseButton: true
          });
          if (revertChanges) {
            //revert to the workspace's state before editing text
            this.workspace.clear();
            Blockly.Xml.domToWorkspace(prevDom, this.workspace);
            this.cleanUpBlocks();
            this.textEditorOpen = false;
          } else {
            //cancel operation & stay in text mode
            this.workspace.clear();
            Blockly.Xml.domToWorkspace(prevDom, this.workspace);
            this.cleanUpBlocks();
            this.textEditorOpen = true;
            this.$refs.controlBar.textEditorOpen = true;
          }
        }
        
      }
    },
    markModified () {
      this.currentProject.modified = true;
    },
    storeDisabledBlocks () {
      let disabledBlocks = this.workspace.getTopBlocks().filter(block=>block.disabled);
      let doms = disabledBlocks.map(block=>Blockly.Xml.blockToDom(block, true));
      let xmls = doms.map(dom=>'<xml xmlns="https://developers.google.com/blockly/xml">'+Blockly.Xml.domToText(dom)+'</xml>');
      this.disabledBlockStorage = xmls;
    },
    restoreDisabledBlocks () {
      
      let doms = this.disabledBlockStorage.map(xml=>Blockly.Xml.textToDom(xml));
      
      doms.forEach(dom=>{
        Blockly.Xml.domToWorkspace(dom, this.workspace);
      });
      
    }
  },
  async mounted() {
    this.isMounted = true;
    await axios.get('toolbox.xml').then(response => (this.blocklyOptions.toolbox = response.data));     

    //The following code is taken from the Blockly docs, as a means to dynamically resize the workspace
    let blocklyDiv = this.$refs["blocklyDiv"];
    let blocklyArea = this.$refs["blocklyArea"];
    this.workspace = Blockly.inject(blocklyDiv, this.blocklyOptions);
    const onResize = () => {
      let element = blocklyArea;
      let x = 0;
      let y = 0;
      do {
        x += element.offsetLeft;
        y += element.offsetTop;
        element = element.offsetParent;
      } while (element);
      blocklyDiv.style.left = x + 'px';
      blocklyDiv.style.top = y + 'px';
      blocklyDiv.style.width = blocklyArea.offsetWidth + 'px';
      blocklyDiv.style.height = blocklyArea.offsetHeight + 'px';
      Blockly.svgResize(this.workspace);
    }
    window.addEventListener('resize', onResize, false);
    this.resizeBlockly = onResize;
    onResize();
    Blockly.svgResize(this.workspace);

    //disable blocks that aren't nested within a parent/function block
    this.workspace.addChangeListener(Blockly.Events.disableOrphans);

    //add listeners for keypresses and update list of which keys are currently pressed,
    //and call the function to run code for event blocks if they exist in this.keyPressListeners
    window.addEventListener('keydown', (e) => {
      let pressedkey = e.key;
      if(pressedkey == ' ') {
        pressedkey = 'Space';
      }
      if(pressedkey in this.keysPressed) {
        this.keysPressed[pressedkey] = true;
      }
      
      let callback = this.keyPressListeners['pressed'][pressedkey]
      if (callback) {
        callback();
      }
    });
    window.addEventListener('keyup', (e) => {
      let pressedkey = e.key;
      if(pressedkey == ' ') {
        e.preventDefault();
        pressedkey = 'Space';
      }
      if(pressedkey in this.keysPressed) {
        this.keysPressed[pressedkey] = false;
      }
      
      let callback = this.keyPressListeners['released'][pressedkey]
      if (callback) {
        callback();
      }
    });
    window.addEventListener('droneEvent', (e)=>{
      // console.log('CAUGHT EVENT', e.detail.eventType);
      let callback = this.droneEventListeners[e.detail.eventType]
      if (callback) {
        callback();
      }
    });

    //populate the file menu (accessible via Open Project...) with the cached projects
    this.loadSavedProjects();

    //watch for any changes to the block workspace to track if the current project is modified
    this.workspace.addChangeListener((event)=>{
      if (event.type != 'ui') {
        this.currentProject.modified = true;
      }
    });

    //on leaving page, prompt user to save their work - also saves the id of the currently open project
    window.addEventListener('beforeunload', (e) => {
      e.preventDefault();
      e.returnValue = 'SAVE YOUR WORK';
      delete e['returnValue'];
      localStorage.setItem('current_project_id', this.currentProject.id);
    });

    //override ctrl-s to save project
    window.addEventListener('keydown', e => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();

        // only open menu if code is not running on the drone
        if (this.codeRunningState == 'not running') {
          this.saveProject();
        }
      }
    });

    //override ctrl-o to open file menu 
    window.addEventListener('keydown', e => {
      if (e.ctrlKey && e.key === 'o') {
        e.preventDefault();

        // only open menu if code is not running on the drone
        if (this.codeRunningState == 'not running') {
          this.fileMenuOpen = true;
        }
      }
    });

    //popup with info about save system for users that haven't seen it yet
    if(!localStorage.getItem('user_has_seen_save_feature')) {
      Swal.fire({
        title: 'You can now save your work!',
        text: 'Open the 3-dot menu on the right to save your projects in the browser or download them to your computer. You can also use ctrl-s and ctrl-o to save and open projects.'
      });
      localStorage.setItem('user_has_seen_save_feature', 'true');
    }
  },
  watch : {
    consoleOutputLog () {
      this.sidebarViewState = 'console';
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap');
/* @import url('https://fonts.googleapis.com/icon?family=Material+Icons'); */
#app {
  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: grid;
  min-height: 100%;
  height: 100%;
}
#grid {
  display: grid;
  grid-template-rows: 60px 65px minmax(0, 1fr) 70px;
  grid-template-columns: 1fr;
  height: 100%;
  min-height: 0;
  max-height: 100%;
}
body {
  overflow: hidden;
}
html, body {
  margin: 0;
  height: 100%;
  font-family: oswald, sans-serif;
  font-weight: 200;
  font-size: 16px;
}
#body{
  height: 100%!important;
}
header {
  background-color: #242323;
}
.code-editor-pane {
  width: 100vw;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: black;
  text-align: center;
  z-index: 100;
  pointer-events: none;
}
button:focus{
    outline: none;
}
#sidebarPane {
  max-height: 100%;
  
  min-width: 200px;
}
.sidebar {
  height: 100%;
  overflow: auto;
}
button {
  font-family: inherit;
  font-weight: inherit;
  font-size: 16px;
  cursor: pointer;
}

#blocklyDiv {
  position: absolute;
}
#blocklyArea {
  width: 100%;
  height: 100%;
}
.disable-editor {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 800;
}
#editorPane {
  transition: none;
  position: relative;
}
#grid .splitpanes--vertical > .splitpanes__splitter {
  width: 12px;
}
#grid .fat-finger > .splitpanes__splitter {
  width: 28px;
}
.blocklyTreeLabel {
  font-family: oswald-extralight, oswald, sans-serif;
  font-size: 20px;
  font-weight: 250;
  /* text-transform: uppercase; */
  color: #242323;
}
.blocklyTreeRow {
  
  border-bottom: 1px solid rgb(235, 235, 235);
  line-height: 40px;
  overflow: hidden;
  padding-right: 6px;
  text-overflow: ellipsis;
  width: 100%;
  height: auto;
  white-space: nowrap;
}
.blocklyToolboxDiv {
  overflow-x: hidden;
  background-color: #fafafa;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 30px;
  width: 250px;
}
.blocklyMainBackground {
  fill: url(#blockly_canvas_fill) !important;
}
.blocklyTextGreen {
  fill: white !important;
}
.blocklyTreeIcon {
  visibility: hidden;
}
input {
  font-family: inherit;
}
.swal2-title {
  font-weight: 500 !important;
  color: inherit !important;
}
.swal2-styled.swal2-confirm {
  background-color: #6f0 !important;
  color: black !important;
}
.swal2-styled.swal2-cancel {
  color: black !important;
}
.swal2-popup {
  background-color: #242323 !important;
  color: #bbb !important;
}
.swal2-content {
  color: inherit !important;
}
</style>
